import React from "react";
import { coloresDelEnlace, COLORES_SUGERIDOS } from "../colorDelEnlace.js";

// Cómo se ve la página pública del enlace: el color de la cabecera y si sale el
// logo de la agencia (Gabriel De Silva, 2026-10-30, E-404). Se guarda con el
// resto del enlace al darle "Guardar". Ocultar el logo aquí solo lo quita de
// ESTA página: correos, PDFs y el portal siguen con el logo de Mi Agencia.
export default function AparienciaDelEnlace({ cfg, setField, lang }) {
  const tt = (es, en) => (lang === "es" ? es : en);
  const ap = cfg.apariencia || { color: null, ocultarLogo: false };
  const poner = (patch) => setField({ apariencia: { ...ap, ...patch } });
  const actual = ap.color || COLORES_SUGERIDOS[0];
  const k = coloresDelEnlace(ap.color);
  const lbl = { fontSize: ".68rem", fontWeight: 700, color: "var(--c-text2,#7aa3c0)", textTransform: "uppercase", letterSpacing: ".04em", marginBottom: 4 };
  return (
    <div>
      <div style={lbl}>{tt("Apariencia de la página", "Page look")}</div>
      <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
        <span style={{ fontSize: ".72rem", color: "var(--c-text2,#7aa3c0)", marginRight: 2 }}>{tt("Color de la cabecera:", "Header color:")}</span>
        {COLORES_SUGERIDOS.map((c, i) => {
          const on = i === 0 ? !ap.color || ap.color === c : ap.color === c;
          return (
            <button key={c} type="button" title={i === 0 ? tt("El de siempre", "Default") : c}
              onClick={() => poner({ color: i === 0 ? null : c })}
              style={{ width: 22, height: 22, borderRadius: "50%", background: c, cursor: "pointer", padding: 0,
                border: on ? "2px solid var(--c-text,#c8dff0)" : "2px solid transparent", boxShadow: on ? "0 0 0 2px var(--c-surface,#0d1f30)" : "none" }} />
          );
        })}
        <label title={tt("Otro color", "Other color")} style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: ".7rem", color: "var(--c-text2,#7aa3c0)", cursor: "pointer" }}>
          <input type="color" value={actual} onChange={(e) => poner({ color: e.target.value })}
            style={{ width: 26, height: 22, padding: 0, border: "1px solid var(--c-border,#1a3550)", borderRadius: 5, background: "transparent", cursor: "pointer" }} />
          {tt("Otro", "Other")}
        </label>
      </div>
      <label style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 8, fontSize: ".74rem", color: "var(--c-text,#c8dff0)", cursor: "pointer" }}>
        <input type="checkbox" checked={!ap.ocultarLogo} onChange={(e) => poner({ ocultarLogo: !e.target.checked })} />
        {tt("Mostrar el logo de la agencia en esta página", "Show the agency logo on this page")}
      </label>
      {/* Vista previa de la cabecera, para ver el color antes de guardar. */}
      <div style={{ marginTop: 8, borderRadius: 10, padding: ".6rem .8rem", background: `linear-gradient(135deg,${k.principal},${k.segundo})`, color: k.sobre, fontSize: ".78rem", fontWeight: 700, textAlign: "center" }}>
        {ap.ocultarLogo ? "" : "[logo] · "}{cfg.meetingTitle || tt("Consulta", "Consultation")}
      </div>
      <div style={{ fontSize: ".62rem", color: "var(--c-text3,#45688a)", marginTop: 4 }}>
        {tt("Ocultar el logo aquí solo lo quita de esta página de citas. Tus correos, PDFs y el portal siguen igual.",
            "Hiding the logo here only removes it from this booking page. Your emails, PDFs and portal stay the same.")}
      </div>
    </div>
  );
}
